var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.5 27.5",
    style: {
      enableBackground: "new 0 0 22.5 27.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1039_2_",
    transform: "translate(411.598 755.957)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2_2_",
    className: "st0",
    cx: -395.1,
    cy: -737.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_503_3_",
    className: "st0",
    d: "M-400.3-729.2c0-2.9,2.3-5.3,5.3-5.3l0,0c2.9,0,5.3,2.4,5.3,5.3l0,0"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "9,25.1 0.8,25.1 0.8,0.8 20.1,0.8 20.1,13.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.5,
    y1: 6.5,
    x2: 16,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.5,
    y1: 10.9,
    x2: 16,
    y2: 10.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.5,
    y1: 15.3,
    x2: 11.3,
    y2: 15.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.0b19dd6c031e5cfa03ceca313d711ecf.svg";
export { ForwardRef as ReactComponent };